import moment from 'moment'

type RangeText = 'day' | 'month'
type CsvReportParams = {
  fileName: string
  range: RangeText
  title: string
}

export class CsvReport {
  fileName: string
  range: RangeText
  title: string

  constructor(params: CsvReportParams) {
    this.fileName = params.fileName
    this.range = params.range
    this.title = params.title
  }

  url(date: Date) {
    return moment(date).format(this.fileName)
  }
}

export type CsvReports = CsvReport[]
